export default class PosVouchersModalController {

    constructor($uibModalInstance, vouchersToDisplay, invoiceInformation) {
        this.modalInstance = $uibModalInstance;
        this.vouchersToDisplay = vouchersToDisplay;
        this.invoiceInformation = invoiceInformation;
    }

    close() {
        this.modalInstance.close();
    }
}

PosVouchersModalController.$inject = [
    '$uibModalInstance',
    'vouchersToDisplay',
    'invoiceInformation'
];



// WEBPACK FOOTER //
// ./src/app/modules/pos/controllers/vouchers-modal-controller.js